<div class="basket-shell-back" (click)="onShellClick($event)" [ngClass]="{ expanded: expanded }"
    *ngIf="itemCount > 0 && !isCheckout"></div>
<div class="basket-shell {{ isCheckout && 'basket-shell--isCheckout' }}">
    <div class="basket-container" [ngClass]="{ shake: !expanded && notifyDelete }">
        <div class="basket-pending-container" *ngIf="pendingUpdateActive" [ngClass]="{
                'basket-pending-container-expanded': pendingUpdates > 0
            }">
            <div class="basket-pending-container-label">Opdaterer kurv...</div>

            <div class="basket-pending-container-spinner">
                <app-ddk-spinner></app-ddk-spinner>
            </div>
        </div>
        <div class="basket-header col-12" *ngIf="itemCount > 0 && toast === true">
            <header class="basket-header-container">
                <div class="basket-header-row">
                    <div class="basket-header-items">
                        <span *ngIf="itemCount > 0">{{ itemCount }}</span><span>
                            {{ itemCount == 1 ? "produkt" : "produkter" }}</span>
                    </div>

                    <div class="basket-header-cta" (click)="toggleExpanded()">
                        {{ expanded ? "Skjul kurv" : "Vis kurv" }}
                    </div>
                </div>
            </header>

            <div class="basket-body" *ngIf="itemCount > 0">
                <app-basket-purchase class="basket-body-container" *ngIf="itemCount > 0 && expanded"
                    [navigate-checkout]="navigateCheckout" [payment-details]="false" [price-factor]="6"
                    (onCloseClick)="toggleExpanded()" (onOpenClick)="toggleExpanded()" [isCheckout]="isCheckout" [showFees]="showFees"
                    [show-per-month]="showPerMonth">
                </app-basket-purchase>
            </div>

            <div class="basket-header-row basket-header-row--sub-row">
                <div class="basket-header-amount">
                 <ng-container *ngIf="totalPrice">   {{ (totalPrice +( showFees && totalFees) )/(showPerMonth ? classCount : 1) | money }}{{
                    (!showPerMonth && classCount ===
                    6) ? "/halvår" : "/md" }} </ng-container>
                </div>
                <div>
                    <!--This is where the button is located-->
                    <ng-content>
                    </ng-content>
                </div>
            </div>
            <app-basket-added-element></app-basket-added-element>
        </div>
    </div>
</div>